import Vue from 'vue'
import VueRouter from 'vue-router'

import vuex from '../store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HanreiDataSystem',
    component: () => import('../views/hanreiSearch/HanreiDataSystem.vue'),
  },
  {
    path: '/hanreiSearch/HanreiSearch',
    name: 'HanreiSearch',
    component: () => import('../views/hanreiSearch/HanreiSearch.vue'),
    meta: { title: '訟務重要判例集検索' },
  },
  {
    path: '/hanreiSearch/DispContent',
    name: 'DispContent',
    component: () => import('../views/hanreiSearch/DispContent.vue'),
    meta: { title: '表示内容について' },
  },
  {
    path: '/hanreiSearch/HanreiSearchRusult',
    name: 'HanreiSearchRusult',
    component: () => import('../views/hanreiSearch/HanreiSearchRusult.vue'),
    meta: { title: '各種検索画面' },
  },
  {
    path: '/hanreiSearch/Error',
    name: 'Error',
    component: () => import('../views/hanreiSearch/Error.vue'),
    meta: { title: '各種検索画面' },
  },
]

// 連続クリックによるルーティングエラーの防止
let routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: () => ({ y: 0 })
})

router.beforeEach((to, from, next) => {
  console.log(to)
  vuex.commit('update', to)
  next(vm => { })
})
export default router
